
$(document).ready(function(){
	$('.moneyInput').each(function(){
		$(this).wrap('<span class="inbl relative moneyInput-container"></span>')
		$(this).parent().append('<span class="currency">€</span>');
	});


});
